import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {Questions} from '../../../domain/questions';
import {FormArray, FormControl, FormGroup, Validators} from '@angular/forms';
import {QuestionService} from '../../../services/question.service';

@Component({
  selector: 'tech-core-quiz-add-question-dialog',
  standalone: false,
  templateUrl: './add-question-dialog.component.html',
  styleUrl: './add-question-dialog.component.scss'
})
export class AddQuestionDialogComponent  implements OnInit {

  public questionStringInput: FormControl<string | null> | undefined
  public correctAnswerInput: FormControl<string | null> | undefined
  public answerOptionOneInput: FormControl<string | null> | undefined
  public answerOptionTwoInput: FormControl<string | null> | undefined
  public answerOptionThreeInput: FormControl<string | null> | undefined
  public formGroup: FormGroup | undefined;
  public question: Questions

  constructor(
    @Inject(MAT_DIALOG_DATA) private data: {question: Questions},
    private dialogRef: MatDialogRef<AddQuestionDialogComponent>,
    private questionService: QuestionService
  ) {
    this.question = data.question;
  }

  ngOnInit(): void {
    this.questionStringInput = new FormControl(this.question?.question ?? '', [Validators.required]);
    this.correctAnswerInput = new FormControl(this.question?.correct_answer ?? '', [Validators.required]);

    if (this.question !== null) {
      let wrongAnswersOnly = this.question.answers.filter(answer => answer !== this.question.correct_answer);

      this.answerOptionOneInput = new FormControl(wrongAnswersOnly[0], [Validators.required]);
      this.answerOptionTwoInput = new FormControl(wrongAnswersOnly[1], [Validators.required]);
      this.answerOptionThreeInput = new FormControl(wrongAnswersOnly[2], [Validators.required]);

    } else {
      this.answerOptionOneInput = new FormControl('', [Validators.required]);
      this.answerOptionTwoInput = new FormControl('', [Validators.required]);
      this.answerOptionThreeInput = new FormControl('', [Validators.required]);
    }

    this.formGroup = new FormGroup<any>({
      questionString: this.questionStringInput,
      correctAnswer: this.correctAnswerInput,
      answerOptionOne: this.answerOptionOneInput,
      answerOptionTwo: this.answerOptionTwoInput,
      answerOptionThree: this.answerOptionThreeInput
    });
  }

  hasQuestionError() {
    if (!this.questionStringInput!!.touched && !this.questionStringInput!!.dirty) {
      return false;
    }

    return this.questionStringInput!!.hasError('required')
  }

  update() {
    if (this.formGroup!!.valid) {
      if (this.question) {
        this.question.question = this.questionStringInput!!.value!;
        this.question.correct_answer = this.correctAnswerInput!!.value!;

        // Create the answers array
        this.question.answers = [
          this.correctAnswerInput!!.value!,
          this.answerOptionOneInput!!.value!,
          this.answerOptionTwoInput!!.value!,
          this.answerOptionThreeInput!!.value!
        ]

        this.questionService.updateQuestion(this.question).subscribe({
          next:  data => {
            this.dialogRef.close({status: 200});
          },
          error: (err) => this.dialogRef.close(err)
        })
      } else {
        const newQuestion = {
          questionId: '100',
          question: this.questionStringInput!!.value!,
          correct_answer: this.correctAnswerInput!!.value!,
          answers: [
            this.correctAnswerInput!!.value!,
            this.answerOptionOneInput!!.value!,
            this.answerOptionTwoInput!!.value!,
            this.answerOptionThreeInput!!.value!
          ]
        }
          this.questionService.createQuestion(newQuestion).subscribe({
            next:  data => {
              this.dialogRef.close({status: 200});
            },
            error: (err) => this.dialogRef.close(err)
          })
      }
    } else {
      this.markAsTouched(this.formGroup!!);
    }
  }

  markAsTouched(formGroup: FormGroup) {
    formGroup.markAsTouched({onlySelf: true});
    Object.keys(formGroup.controls).map((field) => {
      const control = formGroup.get(field);
      if (control instanceof FormControl || control instanceof FormArray || control) {
        control.markAsTouched({onlySelf: true});
      }
    });
  }


}
